import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../_store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'base',
    meta: {
      requiresAuth: true,
    },
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue'),
  },
  {
    path: '/:client/home',
    name: 'Home',
    meta: {
      requiresAuth: true,
    },
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue'),
  },
  {
    path: '/:client/account',
    name: 'Account',
    meta: {
      requiresAuth: true,
    },
    component: () => import(/* webpackChunkName: "account" */ '../views/Account.vue'),
  },
  {
    path: '/:client/about',
    name: 'About',
    meta: {
      requiresAuth: true,
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
  },
  {
    path: '/:client/account/users',
    name: 'Users',
    meta: {
      requiresAuth: true,
    },
    component: () => import(/* webpackChunkName: "users" */ '../views/SystemUsers.vue'),
  },
  {
    path: '/:client/account/profile',
    name: 'Profile',
    meta: {
      requiresAuth: true,
    },
    component: () => import(/* webpackChunkName: "profile" */ '../views/PersonalProfile.vue'),
  },
  {
    path: '/:client/account/client',
    name: 'Client',
    meta: {
      requiresAuth: true,
    },
    component: () => import(/* webpackChunkName: "client" */ '../views/CompanyProfile.vue'),
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue'),
  },
  {
    path: '/forgotpassword',
    name: 'ForgotPassword',
    component: () => import(
      /* webpackChunkName: "forgotpassword" */ '../views/ForgotPassword.vue'
    ),
  },
  {
    path: '/changepassword',
    name: 'ChangePassword',
    component: () => import(
      /* webpackChunkName: "forgotpassword" */ '../views/ChangePassword.vue'
    ),
  },
  {
    path: '/confirmaccount',
    name: 'ConfirmUser',
    component: () => import(
      /* webpackChunkName: "forgotpassword" */ '../views/ConfirmUser.vue'
    ),
  },
  {
    path: '/:client/groups',
    name: 'Groups',
    meta: {
      requiresAuth: true,
    },
    component: () => import(/* webpackChunkName: "groups" */ '../views/Groups.vue'),
  },
  {
    path: '/:client/screens',
    name: 'Screens',
    meta: {
      requiresAuth: true,
    },
    component: () => import(/* webpackChunkName: "screens" */ '../views/Screens.vue'),
  },
  {
    path: '/:client/screens/:id',
    name: 'Screens Details',
    meta: {
      requiresAuth: true,
    },
    component: () => import(/* webpackChunkName: "screens/id" */ '../views/ScreenDetails.vue'),
  },
  {
    path: '/:client/groups/:id',
    name: 'Groups Details',
    meta: {
      requiresAuth: true,
    },
    component: () => import(/* webpackChunkName: "groups/id" */ '../views/GroupDetails.vue'),
  },
  {
    path: '/:client/reconciliation',
    name: 'Reconciliation',
    meta: {
      requiresAuth: true,
    },
    component: () => import(
      /* webpackChunkName: "reconciliation" */ '../views/Reconciliation.vue'
    ),
  },
  {
    path: '/:client/reconciliation/rental/:id',
    name: 'Reconciliation Details',
    meta: {
      requiresAuth: true,
    },
    component: () => import(
      /* webpackChunkName: "reconciliation" */ '../views/ReconciliationDetails.vue'
    ),
  },
  {
    path: '/:client/reconciliation/oneway/:id',
    name: 'One Way Details',
    meta: {
      requiresAuth: true,
    },
    component: () => import(
      /* webpackChunkName: "reconciliation" */ '../views/OneWayDetails.vue'
    ),
  },
  {
    path: '/:client/reports',
    name: 'Reports',
    meta: {
      requiresAuth: true,
    },
    component: () => import(/* webpackChunkName: "reports" */ '../views/Reports.vue'),
  },
  {
    path: '/:client/keys',
    name: 'Keys',
    meta: {
      requiresAuth: true,
    },
    component: () => import(/* webpackChunkName: "reports" */ '../views/KeyCodes.vue'),
  },
  {
    path: '/:client/keys/:id',
    name: 'Keys Details',
    meta: {
      requiresAuth: true,
    },
    component: () => import(/* webpackChunkName: "screens/id" */ '../views/KeyDetails.vue'),
  },
  {
    path: '/:client/devicemap',
    name: 'Devices',
    meta: {
      requiresAuth: true,
    },
    component: () => import(/* webpackChunkName: "screens/id" */ '../views/DeviceMap.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.state.auth.loggedIn) {
      next();
    } else if (localStorage.getItem('auth')) {
      const user = JSON.parse(localStorage.getItem('auth'));
      user.auth.password = new Buffer.from(
        user.auth.password,
        'base64',
      ).toString('ascii');
      store.dispatch('auth/logIn', user, { root: true });
      next();
    } else {
      next('/login');
    }
  } else {
    next();
  }
});

export default router;
